<div class="fallback">
  <div>
    <h2>{{ name }} (Fallback rate)</h2>
    <h3>Shows a backup rate to domestic orders if no delivery methods apply</h3>
    <h4>{{ ratePerDeliveryText }}</h4>
    <pdq-checkbox
      [disabled]="!(isCheckoutEcommerceEnabled$ | async)"
      [formControl]="disableShippingAddress"
      label="Don’t use fallback if shipping address is a PO box"
      (onChange)="onDisableShippingAddressCondition($event)"></pdq-checkbox>
  </div>

  <span class="fallback__actions">
    <pdq-slide-toggle
      class="fallback__toggle"
      [ignoreValueChangeOnToggle]="true"
      [defaultValue]="!!active"
      [disabled]="!(isCheckoutEcommerceEnabled$ | async)"
      (onToggle)="onToggleEnable($event)">
    </pdq-slide-toggle>

    <pdq-dropdown
      [disabled]="disableActions || !(isCheckoutEcommerceEnabled$ | async)"
      class="fallback__dropdown"
      [type]="'button'"
      [options]="actionOptions"
      mode="ghost"
      icon="dots_menu"
      align="right"
      (onChange)="onAction($event)">
    </pdq-dropdown>
  </span>
</div>
